// Page displaying list of metadata items
import {initCore} from 'src/lib/init.js'
import { initSelectAll } from "src/lib/select-all"
import MetadataList from "@/browse/MetadataList.vue"
import 'src/styles/taggle.css'
import 'src/styles/aristotle.less'
import 'src/styles/aristotle.table_browser.less'
import apolloProvider from 'src/lib/graphql/vue-apollo'
import router from 'src/router/router'
import Vue from 'vue'

initCore()
initSelectAll() // this is required the old browse view select all to work

let root = {
    el: '#vue-container',
    apolloProvider,
    router,
    components: {MetadataList}
}
new Vue(root)
